import { colorAttributeCompare, defaultAttributeCompare } from '@features/pdp/attribute-sorting';
import { PDPViews } from '@types';
import { FaAngleLeft } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { useAppDispatch } from '@/store';
import { getItem, setView } from '../../../actions/pdp.actions';
import ColorSwatches from '../../../components/ColorSwatches';
import { Button } from '../../../components/tailwind';
import MoreColorsSwatch from '../../../components/tailwind/MoreColorsSwatch';
import Swatches from '../components/ProductSwatches/Swatches';
import { MIYO_DISABLED_COLORS } from '../settings';

const MAX_SWATCHES_SHOWN = 5;

const Header = ({ onMoreClick }) => {
  const dispatch = useAppDispatch();
  const { details, variants } = useSelector((state: any) => state.pdpItem);

  if (!details || !variants) return null;

  const colors =
    variants?.colors
      ?.filter((color) => !MIYO_DISABLED_COLORS.includes(color.id) && color.isInStock && color.isAvailable)
      .toSorted(colorAttributeCompare) ?? [];

  const changeItemHandler = (swatchData) => () => {
    dispatch(getItem(swatchData.url));
  };

  const backHandler = () => {
    dispatch(setView(PDPViews.DEFAULT));
  };

  return (
    <div className='tw-fixed tw-left-0 tw-right-0 tw-top-0 tw-z-10 tw-w-screen tw-border-b tw-border-b-gray-300 tw-bg-white tw-px-[10px] tw-py-3 lg:tw-hidden lg:tw-px-6 lg:tw-py-6'>
      <div className='tw-mx-auto tw-flex tw-w-full tw-max-w-[1440px] tw-items-center tw-justify-between tw-gap-6'>
        <Button variant='unstyled' noPadding onClick={backHandler} className='tw-w-full lg:tw-w-1/2'>
          <div className='tw-flex tw-w-full tw-items-center tw-gap-[10px]'>
            <FaAngleLeft size={16} />
            <p className='tw-mb-0 tw-inline-flex tw-w-full tw-items-center tw-gap-[6px] tw-text-xs lg:tw-text-sm'>
              <span>Personalize with</span>
              <img
                src='/assets/images/rtic/myRTIC-Logo.png'
                alt='MyRTIC Logo'
                className='tw-max-h-3 tw-w-full tw-max-w-[60px]'
              />
            </p>
          </div>
        </Button>

        <div className='tw-hidden tw-justify-end tw-gap-10 lg:tw-inline-flex'>
          <div>
            {variants?.show.sizes && (
              <Swatches
                label='Size'
                attributes={variants?.sizes
                  ?.filter(
                    (s) =>
                      (s.isAvailable && s.isInStock) ||
                      (variants?.activeSize && s.id === variants?.activeSize?.id)
                  )
                  .toSorted(defaultAttributeCompare)
                  .slice(0, MAX_SWATCHES_SHOWN)}
                activeAttribute={variants?.activeSize}
                itemHandler={changeItemHandler}
                wrapperClassName=''
                indicateSale={false}
                swatchSize='sm'
              />
            )}
          </div>
          <div>
            {variants?.show.colors && (
              <ColorSwatches
                colors={colors.slice(0, MAX_SWATCHES_SHOWN)}
                activeColor={variants?.activeColor}
                itemHandler={changeItemHandler}
                wrapperClassName=''
                indicateSale={false}
                indicateClearance={false}
                swatchSize='sm'
                swatchesAddendum={
                  colors.length > MAX_SWATCHES_SHOWN && (
                    <MoreColorsSwatch onMoreClick={onMoreClick} size={28} />
                  )
                }
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
